import Communicator, { ContentWindow } from '@branchjs/communicator';
import React from 'react';

export const isLocalhost = !localStorage.getItem('force_env_name') && window.location.origin.indexOf('localhost') >= 0;

const ALLOWED_ORIGINS = [
  'branch.io',
  'cdn.branch.io',
  'stage.branch.io',
  'd3t0vyzb3ndf7j.cloudfront.net',
  'localhost:3001',
  'localhost:3000',
  'localhost:9000',
  'localhost:9008',
  'localhost:9010',
];

const createContentWindow = (id: string, localhostPort: number) =>
  isLocalhost
    ? ContentWindow.create(id, `http://localhost:${localhostPort}`)
    : ContentWindow.create(id, 'https://cdn.branch.io/');

export const CommunicationContext = React.createContext({
  communicator: new Communicator(ALLOWED_ORIGINS, [
    createContentWindow('journeys-creatives-mf', 3001),
    createContentWindow('link-templates-mf', 9000),
    createContentWindow('journeys-creatives-optimization-mf', 9000),
    createContentWindow('postbacks-form-mf', 9000),
    createContentWindow('alert-notifications-mf', 9000),
    createContentWindow('qr-code-customizations-mf', 9000),
    createContentWindow('link-manager-mf', 9008),
    createContentWindow('usage-mf', 9010),
    createContentWindow('disco-dashboard-mf', 9000),
  ]),
});
